import { render, staticRenderFns } from "./InquiriesTips.vue?vue&type=template&id=01162cbd&"
import script from "./InquiriesTips.vue?vue&type=script&lang=js&"
export * from "./InquiriesTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports